export function formatAuthorJobTitle(
  jobTitle?: string | null,
  company?: string | null,
): string | null {
  const role = jobTitle?.trim() || null
  const org = company?.trim() || null
  if (role && org) return `${role} at ${org}`
  return role ?? org ?? null
}
